globalThis.ShareEvents = (function() {
  function ShareEvents($html) {
    this.$html = $html;

    utils.require([assets.sharer], function(){
      window.Sharer.init();
    });
  }

  ShareEvents.initEvents = function($html, options) {
    $.each($html, function() {
      var shareEvents = new ShareEvents($(this), options);
      shareEvents.init();
    });
  }

  ShareEvents.prototype = {
    init: function () {
      var me = this;

      var clipboards = new Clipboard('.clipboard');
      clipboards.on('success', function(e) {
        $(document).trigger('clipboard.success', [$(e.trigger)]);
      }).on('error', function(e) {
        $(document).trigger('clipboard.error', [$(e.trigger)]);
      });

      me.$html.on('click', 'button', function() {
        var $this = $(this);
        var $buttonsContainer = me.$html.find('.social-media-share-buttons-container');
        var url = $buttonsContainer.data('ajax-url');

        $.ajax({
          type: 'POST',
          url:  url,
          data: {
            share_channel: $this.data('sharer'),
            article_id: $buttonsContainer.data('article-id')
          }
        });
      })
    }
  }

  return ShareEvents;
})();
